import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('creation_of_templatename'),
    title: defineMessage('there_are_several_metho_nd_choose_as_applicable_1'),
    createInApprovalMax: defineMessage('create_in_approvalmax'),
    description: defineMessage('add_users_authorised_to_approval_in_approvalmax_2'),
};
